import React, { useState } from "react";
import styles from './ForgotPasswordForm.module.scss';
import Logo from "../logo/Logo";
import TextField from "../textField/TextField";
import Alert from "../alert/Alert";
import Button from "../button/Button";
import PropTypes from "prop-types";

const ForgotPasswordForm = ({onSubmit, error}) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const validateEmail = () => {
    if(!email) {
      return 'Email is required';
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!regex.test(email)) {
      return 'Email is invalid';
    }
    return '';
  };

  const hanldeLogin = () => {
    const emailValidationResult = validateEmail();
    
    setEmailError(emailValidationResult);

    if (emailValidationResult) {
      return false;
    }

    onSubmit(email);
  };

  return (
    <div className={styles.container}>
      <Logo />
      <h1 className={styles.title}>Forgot Password?</h1>
      <div className={styles.description}>
        <p>Enter the email address registered with Maestro and we’ll send you instructions to reset your password.</p>
        <p>For security reasons, we do NOT store your password. So rest assured that we will never send your password via email.</p>
      </div>
      { error && <Alert message={error} type="error" /> }
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          hanldeLogin();
        }}
      >
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(value) => setEmail(value)}
          error={emailError}
        />
        <div className={styles.submit}>
          <Button
            label="Send Reset Instructions"
            type="submit"
            fullWidth
          />
        </div>
      </form>
    </div>
  );
};

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default ForgotPasswordForm;